<template>
    <div class="row">
        <div class="col-12 mb-1">
            <table class="table table-sm table-bordered mb-0">
                <tbody>
                    <tr>
                        <th>Hesaplanan {{(value.TIP == 1 && value.SIRA_NO==35) ? 'Fazla Mesai' : 'Hafta Tatili Mesaisi'}}</th>
                        <td>{{value.SystemCalculated}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <label class="form-label">Eklenen Süre</label>
            <hr class="my-25"/>
            <div class="d-flex align-items-center">
                <div class="w-100">
                    <label class="form-label">Saat</label>
                    <div class="d-flex align-items-center">
                        <select class="form-control mr-50" v-model="hour" v-on:change="setTime">
                            <option v-for="(h,i) in maxHour" :value="i" :key="i">{{i < 10 ? `0${i}` : i}}</option>
                        </select>
                        :
                    </div>
                </div>
                <div class="w-100">
                    <label class="form-label mx-50">Dakika</label>
                    <div class="d-flex align-items-center">
                        <select class="form-control mx-50" v-model="min" v-on:change="setTime">
                            <option v-for="(h,i) in maxMinSecond" :value="i" :key="i">{{i < 10 ? `0${i}` : i}}</option>
                        </select>
                        :
                    </div>
                </div>
                <div class="w-100">
                    <label class="form-label mx-50">Saniye</label>
                    <select class="form-control ml-50" v-model="second" v-on:change="setTime">
                        <option v-for="(h,i) in maxMinSecond" :value="i" :key="i">{{i < 10 ? `0${i}` : i}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return {
            maxHour:301,
            maxMinSecond:60,
            hour:0,
            min:0,
            second:0
        }
    },
    mounted(){
        this.convert()
    },
    methods:{
        setTime(){
            const ho = parseInt(this.hour / 24)
            const ch = this.hour - ho * 24 
            this.value.Time = [ho < 1 ? null : ho,[
                ch < 10 ? `0${ch}` : ch, 
                this.min < 10 ? `0${this.min}` : this.min,
                this.second < 10 ? `0${this.second}` : this.second
            ].join(':')].filter(s=>s).join('.')
        },
        convert(){
            try {
                if(this.value.Time){
                    const splitedHour = (this.value.Time || "")?.split('.')
                    if(splitedHour.length == 2){
                        const splitedTime = splitedHour[1].split(':')
                        console.log(splitedHour)
                        if(splitedHour[0]){
                            this.hour = Number(splitedHour[0]) * 24 + Number(splitedTime[0])
                            this.min =  Number(splitedTime[1])
                            this.second = Number(splitedTime[2])
                        }
                    }else{
                        const splitedTime = this.value.Time?.split(':') || []
                        if(splitedTime.length == 3){
                            this.hour = Number(splitedTime[0])
                            this.min = Number(splitedTime[1])
                            this.second = Number(splitedTime[2])
                        }else{
                            this.hour = 0
                            this.min = 0
                            this.second = 0
                        }
                    }
                }else{
                    this.hour = 0
                    this.min = 0
                    this.second = 0
                }
            } catch (e) {
                console.log(e)
                this.hour = 0
                    this.min = 0
                    this.second = 0
            }
        }
    }
}
</script>

<style>

</style>